import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ spacing }: HeaderTheme) => ({
  actions: {
    display: 'flex',
    marginRight: spacing[4],

    '& > a, & > button': {
      border: 'none',
      margin: `0 ${spacing[1]}px`,
      textDecoration: 'none',
    },
  },
}));

export default useStyles;
